import { useMemo } from "react";

import {
  makeMetadataFromCandidates,
  metadataMapper
} from "../../utils/metadata";

export function useCandidatesData({
  candidates = [],
  metadata = {
    total: 0,
    registered: 0,
    external: 0
  },
  filters = {
    registered: ""
  }
}) {
  const candidatesMetadata = useMemo(
    () => metadata || makeMetadataFromCandidates(candidates),
    [candidates, metadata]
  );

  const hasMetadata = useMemo(() => Boolean(metadata), [metadata]);

  const mappedMetadata = useMemo(
    () =>
      metadataMapper({
        metadata: candidatesMetadata,
        source: filters.registered
      }),
    [candidatesMetadata, filters.registered]
  );

  return {
    hasMetadata,
    mappedMetadata,
    metadata: candidatesMetadata
  };
}
